let code = 'cosicentral';
let codeAPI = 'cosi';
let codeMANAGE = 'cosigestao';
let codeFRONT = 'cosi';
export const apiConstants = {
    code: `${code}`,
    codeAPI: `${codeAPI}`,
    baseUrlAPI: `${codeAPI}/central`,
    codeMANAGE: `${codeMANAGE}`,
    codeFRONT: `${codeFRONT}`,
};
